/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Сущность политики отмены
 * @export
 * @interface CancellationPolicyInfoDto
 */
export interface CancellationPolicyInfoDto {
    /**
     * Возможно ли бесплатная отмена
     * @type {boolean}
     * @memberof CancellationPolicyInfoDto
     */
    freeCancellationPossible: boolean;
    /**
     * Дата и время (включительно), до которых бронирование может быть отменено бесплатно (без штрафа). Если ‘null’, см. freeCancellationPossible. ‘null’ и freeCancellationPossible=true - только бесплатная отмена. ‘null’ и freeCancellationPossible=false - бесплатная отмена невозможна.
     * Локальная дата и время для отеля. Формат соответствует ISO-8601 YYYY-MM-DDThh:mm
     * 
     * @type {Date}
     * @memberof CancellationPolicyInfoDto
     */
    freeCancellationDeadlineLocal?: Date | null;
    /**
     * То же, что и freeCancellationDeadlineLocal, но дата и время в UTC. Формат соответствует ISO-8601 YYYY-MM-DDThh:mmZ
     * 
     * @type {Date}
     * @memberof CancellationPolicyInfoDto
     */
    freeCancellationDeadlineUtc?: Date | null;
    /**
     * Сумма штрафа за отмену по ближайшему условию отмены, на период поиска. Например, freeCancellationDeadline=2019-09-30T09:00Z, если отменено 2019-09-30T09:01Z, штраф будет равен penaltyAmount. null - всегда бесплатная отмена. В зависимости от даты отмены, сумма штрафа может варьироваться в обе стороны.
     * 
     * @type {number}
     * @memberof CancellationPolicyInfoDto
     */
    penaltyAmount?: number | null;
}

/**
 * Check if a given object implements the CancellationPolicyInfoDto interface.
 */
export function instanceOfCancellationPolicyInfoDto(value: object): value is CancellationPolicyInfoDto {
    if (!('freeCancellationPossible' in value) || value['freeCancellationPossible'] === undefined) return false;
    return true;
}

export function CancellationPolicyInfoDtoFromJSON(json: any): CancellationPolicyInfoDto {
    return CancellationPolicyInfoDtoFromJSONTyped(json, false);
}

export function CancellationPolicyInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancellationPolicyInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'freeCancellationPossible': json['freeCancellationPossible'],
        'freeCancellationDeadlineLocal': json['freeCancellationDeadlineLocal'] == null ? undefined : (new Date(json['freeCancellationDeadlineLocal'])),
        'freeCancellationDeadlineUtc': json['freeCancellationDeadlineUtc'] == null ? undefined : (new Date(json['freeCancellationDeadlineUtc'])),
        'penaltyAmount': json['penaltyAmount'] == null ? undefined : json['penaltyAmount'],
    };
}

  export function CancellationPolicyInfoDtoToJSON(json: any): CancellationPolicyInfoDto {
      return CancellationPolicyInfoDtoToJSONTyped(json, false);
  }

  export function CancellationPolicyInfoDtoToJSONTyped(value?: CancellationPolicyInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'freeCancellationPossible': value['freeCancellationPossible'],
        'freeCancellationDeadlineLocal': value['freeCancellationDeadlineLocal'] == null ? undefined : ((value['freeCancellationDeadlineLocal'] as any).toISOString()),
        'freeCancellationDeadlineUtc': value['freeCancellationDeadlineUtc'] == null ? undefined : ((value['freeCancellationDeadlineUtc'] as any).toISOString()),
        'penaltyAmount': value['penaltyAmount'],
    };
}

